import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class GoodsApp extends React.Component
{
    constructor(){
        super();
        Tools.init();
        API.init(this);
        
        this.state = {
            ty: 0,
            sz: this.DEFAULT_MAX,
            list: [],
            page_max: 20,
            filter: null,
            list_index_min:0,
            list_index_max:20,
            page_index:0,
            fields: [
                "禮物編號",
                "禮物名稱",
                "禮物類型",
                "上架日期",
                "下架日期"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData(){
        var tmpData = {
            ty: this.state.ty
        };
        API.GetGoods(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index){
        console.log(index);
        // window.open("record.html?gi="+index);
        // location.href = "detail.html?gi="+index;
        // window.open("edit.html?gi="+index);
        let path = '/#/goods/detail/' + index;
        // this.props.history.push(path);
        window.open(path);
    }

    onDataUpdated(data){
        console.log(this);
        if( data && data.data ){
            console.log(data);
            const tmp = [];
            /* {
                "end_at": "1577721600000",
                "images": [
                    "gifts/261/z1s8lda25fzfbsnbona79qfw1j6nufcm.jpg"
                ],
                "is_recom": "0",
                "gid": "GE181211172613",
                "g_type": "0",
                "icon": "gifts/261/ws8ij2ywltrntsvy38xn1ki9qrfvehqt.jpg",
                "description": "►獎品介紹：7-11購物金35元。 \n►領獎方式：憑序號可免費獲得乙份7-ELEVEN 35元商品抵用券，自由兌換店內商品。\n►兌換方式（可任選一種方式兌換）：\n1.下載ibon行動生活站 APP→好康紅利→i禮贈→輸入12碼序號→閱讀兌換須知→至門市櫃檯出示條碼兌換。 \n2.請至門市ibon選擇好康/紅利→好康活動→i禮贈序號補卷→閱讀兌換須知→輸入12碼序號→列印紙本小白單卷後，持卷至門市櫃檯兌換 \n3.詳細兌換方式請參考:http://goo.gl/Fj1Afl \n►電子禮卷使用注意事項： \n1.本卷使用問題請洽智慧時尚客服中心：02-2377-6966。服務時間：周一至周五上午10:00至下午6:00。\n2.請於禮卷使用期限前至7-11門市兌換完畢，逾期恕無法使用及補發。 \n3.使用時須符合本載明之品牌與規格。商品兌換完成後，恕無法提供退貨及換貨。因各門市實際販售商品不同、兌換商品數量有限，若該門市已無存貨請至鄰近其他7-ELEVEN門市兌換。 \n4.不適用非開立7-ELEVEN發票之特殊門市 （如：台鐵門市、部分學校、廠辦及商場門市）與離島門市，請至鄰近其他門市兌換。 \n5.本卷不得折抵現金,現金抵用卷恕不找零。 \n6.本卷不可與其他行銷活動合併使用。也不計入7-ELEVEN舉辦之全店集點活動消費金額內。 \n7.本卷與兌換卷應妥善保管，若被盜用、損毀、遺失或因為保存不當造成模糊無法辨識而無法兌換，恕無法補發。 \n8.本卷不得使用代收、代售業務及健康捐商品（如：香菸）及儲值（如：icash、悠遊卡等）。",
                "created_at": "1544520373814",
                "max_roll": "0",
                "source": "dataa",
                "start_at": "1544371200000",
                "type": "1",
                "goods_remain": "500",
                "point": "35",
                "is_top": "0",
                "created_id": "admin",
                "updated_at": "1544520373814",
                "recv_type": "0",
                "is_del": "0",
                "name": "7-11購物金35元",
                "goods_num": "500",
                "cash_point": "0",
                "updated_id": "admin"
            } */
            for( let index in data.data ) {
                const tmpObj = data.data[index];
                // "禮物編號",
                // "禮物名稱",
                // "禮物類型",
                // "上架日期",
                // "下架日期"
                tmp.push({
                    key: tmpObj.gid,
                    data: [
                        tmpObj.gid,
                        tmpObj.name,
                        tmpObj.type,
                        Tools.getFormatDate(tmpObj.start_at),
                        Tools.getFormatDate(tmpObj.end_at)
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list} 
                          fields={fields}
                          title={"禮物列表"}
                          onRowClicked={onListViewClicked}/>
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(GoodsApp),
//     document.getElementById('root')
// );


const mapStateToProps = (state) => ({
    id:  state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(  
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GoodsApp))